export default "__VITE_ASSET__yhNLwK89__"